import { render, staticRenderFns } from "./LayoutDialog.vue?vue&type=template&id=2f3a3d17&scoped=true"
import script from "./LayoutDialog.vue?vue&type=script&lang=js"
export * from "./LayoutDialog.vue?vue&type=script&lang=js"
import style0 from "./LayoutDialog.vue?vue&type=style&index=0&id=2f3a3d17&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3a3d17",
  null
  
)

export default component.exports